import { Expose } from 'class-transformer';
import { TransformDate } from 'src/app/common/util/transform-date';

export class DisplaySynchronization {

    @Expose()
    @TransformDate()
    syncTime: Date;

}
